import DetailsBlock from './DetailsBlock';

export default DetailsBlock;
